import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    output,
    viewChild
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    AixSendMessageComponent,
    DocuSignForm,
    ErrorWrapper,
    eSignEnvelopeRecipient
} from '@trade-platform/ui-shared';
import { Observable, Subscription } from 'rxjs';
import { ProfileStoreFacade } from '@advisor-ui/app-services';
import { recipientType } from '@trade-platform/lib-enums';
import {
    AixButtonComponent,
    AixDataTestingDirective,
    AixHeaderSectionComponent,
    AixInputComponent,
    BUTTON_TYPE
} from '@trade-platform/ui-components';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';

import { AixSignerComponent } from '../signer/signer.component';
import { AixSignerFilterPipe } from '../pipes/signers.pipe';
import { RemoteData } from 'ngx-remotedata';
import { BaseOrdersStoreFacade, ORDERS_STORE_FACADE } from '@advisor-ui/orders';

@Component({
    selector: 'aix-docu-sign',
    templateUrl: './recipients.html',
    styleUrls: ['./recipients.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        AixHeaderSectionComponent,
        AixDataTestingDirective,
        AixButtonComponent,
        AixSignerComponent,
        FormsModule,
        ReactiveFormsModule,
        AixSignerFilterPipe,
        AixSendMessageComponent,
        AixInputComponent
    ]
})
export class AixOrderProcessDocuSignRecipientsComponent {
    private environment = inject<IEnvironment>(ENVIRONMENT);
    store = inject<BaseOrdersStoreFacade>(ORDERS_STORE_FACADE);
    profileStore = inject(ProfileStoreFacade);

    sendMessageComponent = viewChild.required<AixSendMessageComponent>('sendMessageComponent');
    signers = input.required<eSignEnvelopeRecipient[]>();
    states = input.required<Observable<RemoteData<any, string | ErrorWrapper>>[]>();
    recipientError = input<string>('');
    recipients = computed(() => this.recipientError().split(','));

    cancelESign = output();
    submitForm = output<DocuSignForm>();

    docusignEmail: string;

    recipientType = recipientType;

    subscriptions: Subscription[] = [];

    cancelEsignButtonType = BUTTON_TYPE.link;
    sendEsignButtonType = BUTTON_TYPE.primary;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const environment = this.environment;

        this.docusignEmail = environment.contactDetails.docusignEmail;
    }

    editOrder() {
        this.store.actions.makeChanges.dispatch({ orderId: this.store.order.id });
    }

    onSubmit() {
        this.sendMessageComponent().sendForm.updateValueAndValidity();
        if (this.sendMessageComponent().sendForm.valid) {
            this.submitForm.emit(this.sendMessageComponent().sendForm.value);
        }
    }
}
